import{withTheme as e}from"emotion-theming";export{ThemeProvider}from"emotion-theming";import{css as t,jsx as o}from"@emotion/core";import{rgba as i,lighten as n,stripUnit as r,darken as a,em as l}from"polished";import s,{Component as c}from"react";import{noop as p,isNull as d,merge as h}from"lodash-es";import f from"classnames";import m from"@emotion/css";import{Map as g,TileLayer as x,WMSTileLayer as b,ScaleControl as u}from"react-leaflet";import y from"resize-observer-polyfill";import v,{CRS as w}from"leaflet";import"leaflet/dist/leaflet.css";import $ from"@emotion/styled";import{useBoolean as k}from"react-hanger";import C from"react-outside-click-handler";const z={typography:{baseFontSize:10,h1:{fontSize:28,fontFamily:"Arial, Helvetica, sans-serif"},h2:{fontSize:24,fontFamily:"Arial, Helvetica, sans-serif"},h3:{fontSize:16,fontFamily:"Arial, Helvetica, sans-serif"},h4:{fontSize:14,fontFamily:"Arial, Helvetica, sans-serif"},paragraph:{fontFamily:"Comic Sans MS"}},navigationItem:{default:{backgroundColor:"#F1F1F1",iconColor:"#737373"},active:{backgroundColor:"#FFE615",iconColor:"#212121",borderColor:"#000"}}};const E=t`
  position: relative;
  z-index: 999;
  pointer-events: auto;
  display: flex;
  flex-direction: column;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`,M=e=>o("div",Object.assign({css:t`
        position: absolute;
        pointer-events: none;
        width: auto;
        display: flex;
        flex-direction: column;

        & > * {
          margin-top: 15px;
        }
        & > *:first-child {
          margin-top: 0px;
        }

        ${"TOP_LEFT"===e.position&&t`
            left: 25px;
            top: 20px;
            align-items: flex-end;
          `}

        ${"TOP_RIGHT"===e.position&&t`
            right: 25px;
            top: 20px;
            align-items: flex-end;
          `}

        ${"BOTTOM_RIGHT"===e.position&&t`
            right: 25px;
            bottom: 40px;
            align-items: flex-end;
          `}

        ${"BOTTOM_LEFT"===e.position&&t`
            left: 25px;
            bottom: 20px;
            align-items: flex-end;
          `}
      `},e),e.children),S=e=>{var{isactive:i=!1}=e,n=function(e,t){var o={};for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&t.indexOf(i)<0&&(o[i]=e[i]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(i=Object.getOwnPropertySymbols(e);n<i.length;n++)t.indexOf(i[n])<0&&(o[i[n]]=e[i[n]])}return o}(e,["isactive"]);return o("div",Object.assign({onClick:n.onClick,css:t`
        ${E};

        background-color: #f8f8f8;
        border-radius: 100%;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 300ms;


        ${n.disabled&&t`
            cursor: not-allowed;
            opacity: 0.6;
          `}

        ${"small"===n.size&&t`
            width: 28px;
            height: 28px;
            box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.16);
            > svg {
              width: 14px;
              height: 14px;
            }
          `}
        ${"medium"===n.size&&t`
            width: 32px;
            height: 32px;
            box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.16);
            > svg {
              width: 14px;
              height: 16px;
            }
          `}
        ${"large"===n.size&&t`
            width: 44px;
            height: 44px;
            box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16);
            > svg {
              width: 18px;
              height: 18px;
            }
          `}

        ${i&&t`
            background-color: #ffe615;
          `}
      `},n),n.children)};S.defaultProps={size:"medium",isactive:!1};const O=e=>o("div",Object.assign({css:t`
        ${E}
      `},e),e.children),A=i(204,204,204,.75),F=t`
  cursor: pointer;
  height: ${"1px"};
  transition: all 0.2s ease;
  width: ${"100%"};
`,I=(e,o,i)=>t`
  box-shadow: ${e} ${e} ${o} ${i},
    0 0 ${e} ${n(.5,i)};
`,N=t`
  ${I("3px","10px","rgba(0, 0, 0, 0.2)")}
  background: ${"#212121"};
  border: ${"0px"} solid ${"#eceff1"};
  border-radius: ${"12px"};
  cursor: pointer;
  height: ${"12px"};
  width: ${"12px"};
`,P=t`
  -webkit-appearance: none;
  margin: ${"12px"} / 2 0;
  width: ${"100%"};
  padding: 0;

  &:focus {
    outline: 0;

    &::-webkit-slider-runnable-track {
      background: ${n(.05,A)};
    }

    &::-ms-fill-lower {
      background: ${A};
    }

    &::-ms-fill-upper {
      background: ${n(.05,A)};
    }
  }

  &::-webkit-slider-runnable-track {
    ${F}
    ${I("0","0","rgba(0, 0, 0, 0.2)")}
    background: ${A};
    border: ${"0"} solid ${"#cfd8dc"};
    border-radius: ${"5px "};
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    ${N}
    margin-top: ${(2*-r("0")+r("1px"))/2-r("12px")/2}px;
  }

  &::-moz-range-track {
    ${F}
    ${I("0","0","rgba(0, 0, 0, 0.2)")}
    background: ${A};
    border: ${"0"} solid ${"#cfd8dc"};
    border-radius: ${"5px "};
  }

  &::-moz-range-thumb {
    ${N}
  }

  &::-ms-track {
    ${F}
    background: transparent;
    border-color: transparent;
    border-width: (${"12px"} / 2) 0;
    color: transparent;
  }

  &::-ms-fill-lower {
    ${I("0","0","rgba(0, 0, 0, 0.2)")}
    background: ${a(.05,A)};
    border: ${"0"} solid ${"#cfd8dc"};
    border-radius: ${"5px "} * 2;
  }

  &::-ms-fill-upper {
    ${I("0","0","rgba(0, 0, 0, 0.2)")}
    background: ${A};
    border: ${"0"} solid ${"#cfd8dc"};
    border-radius: ${"5px "} * 2;
  }

  &::-ms-thumb {
    ${N}
    margin-top: 0;
  }
`;class L extends c{constructor(e){super(e),this.state={value:e.value}}handleChange(e){const t=parseInt(e.currentTarget.value);this.props.onChange(t),this.setState({value:t})}render(){return o("input",{type:"range",css:P,className:f(this.props.className),value:this.state.value,min:this.props.min,max:this.props.max,step:this.props.step,onChange:this.handleChange.bind(this)})}}L.defaultProps={step:10,onChange:p};const T={window:m`
    position: relative;
    width: fit-content;
    max-width: 500px;
    height: auto;
    display: flex;
    flex-direction: column;
  `,header:m`
    background-color: #838383;
    flex: 0 0 30px;
    display: flex;
    align-items: center;
    padding: 0 8px 0 16px;
    justify-content: space-between;
    /* font-size: emy(11); */
    /* font-family: $font-family-avenir-roman; */
    text-transform: uppercase;
  `,body:m`
    background-color: #f8f8f8;
    padding: 16px;
    flex-grow: 1;
    /* font-family: $font-family-avenir-light; */
    /* font-size: emy(11); */
    line-height: 1.4em;
    overflow: auto;
  `,title:m`
    color: #ffffff;
    padding: 10px 0 8px;
  `,close:m`
    width: 16px;
    height: 16px;
    cursor: pointer;
    // position: absolute;
    padding: 4px;
    right: 10px;
    top: 5px;
  `,icon:m`
    width: 100%;
    height: 100%;
    fill: #ffffff;
  `},_=e=>o("div",{css:T.window,className:e.className},o("div",{css:T.header},o("span",{css:T.title},e.title),o("div",{css:T.close,onClick:e.onClose},o("svg",{version:"1.1",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 512 512",css:T.icon},o("path",{d:"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"})))),o("div",{css:T.body},e.children)),R={legend:m`
    & + & {
      padding-top: 20px;
    }
  `,header:m`
    display: flex;
    justify-content: space-between;
    color: #838383;
    padding-bottom: 10px;
    flex-direction: column;
  `,title:m`
    font-size: 1rem;
    text-transform: uppercase;
    /* font-family: $font-family-avenir-black; */
    /* font-size: remy(13); */
    color: #3e4960;
  `,entity:m`
    font-size: 0.8rem;
    /* font-family: $font-family-avenir-light; */
    /* font-size: remy(9); */
  `,scale:m`
    display: flex;
    flex-direction: column;
  `};var j;!function(e){e.SOLID_LINE="solid_line",e.RECTANGLE="rectangle"}(j||(j={}));class B extends c{render(){const{legend:e}=this.props;return o("div",{css:R.legend},o("div",{css:R.header},o("div",{css:R.title},e.title),e.entity&&o("div",{css:R.entity},o("span",{dangerouslySetInnerHTML:{__html:e.entity}}))),o("div",{css:R.scale},e.legendItems.map((e,t)=>o(V,{data:e,key:t}))))}}const H={scaleItem:t`
    display: flex;
    flex-direction: row;

    & + .scaleItem {
      margin-top: 3px;
    }
  `,scaleVisualContainer:t`
    position: relative;
    display: flex;
    width: 25px;
    height: 10px;
    margin-right: 10px;
    margin-top: 3px;
    flex: 0 0 auto;
    align-items: center;
  `,scaleVisual:e=>t`
    width: 100%;
    height: 100%;

    ${e.data.type===j.RECTANGLE&&t`
        width: 100%;
        height: 100%;
      `}
    ${e.data.type===j.SOLID_LINE&&t`
        width: 100%;
        height: 1px;
      `}
  `,scaleValue:t`
    font-size: 1rem;
    color: #838383;
  `,scaleLabel:t`
    /* font-family: $font-family-avenir-roman; */
    font-size: remy(11);
    color: #707070;
  `},V=e=>{const{data:t}=e;return o("div",{css:H.scaleItem},o("div",{css:H.scaleVisualContainer},o("div",{css:H.scaleVisual(e),style:{backgroundColor:t.color}})),o("div",{css:H.scaleLabel},t.label))},Z={container:m`
    position: relative;
    display: block;
    width: fit-content;
  `,colorMapRamp:m`
    display: flex;
    flex-direction: row;
    padding-left: 5px;
  `,colorMapEntries:m`
    display: flex;
    flex-direction: column;
  `,colorMapEntry:m`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    height: 18px;
  `,colorMapEntryLabel:m`
    color: #242a38;
    font-size: emy(11);
    padding-left: 4px;
  `},q=e=>{const{colorMap:t}=e;return o("div",{css:Z.container},o("div",{css:Z.colorMapRamp},o("svg",{width:"40"},o("linearGradient",{id:"jet_r",x1:"0",x2:"0",y1:"0",y2:"1"},t.entries.map((e,i)=>o("stop",{key:i,offset:i/(t.entries.length-1)*100+"%  ",stopColor:e.color}))),o("rect",{x:"0",y:"0",rx:"0",ry:"0",width:"40",height:18*t.entries.length,fill:"url(#jet_r)",id:"legendOriginal"})),o("div",{css:Z.colorMapEntries},t.entries.map((e,i)=>o("div",{key:i,css:Z.colorMapEntry},o("div",{css:Z.colorMapEntryLabel},0===i&&"≦",i===t.entries.length-1&&"≧",e.quantity.toFixed(1)))))))},D={container:m`
    position: relative;
    display: block;
    width: fit-content;
  `,colorMapIntervals:m`
    display: flex;
    flex-direction: column;
    padding-left: 5px;
  `,colorMapEntry:m`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    height: 18px;
    width: 100%;
  `,colorMapEntryVisual:m`
    width: 31px;
    height: 13px;
  `,colorMapEntryLabel:m`
    color: #242a38;
    font-size: emy(11);
    padding-left: 4px;
  `},G=e=>{const{colorMap:t}=e;return o("div",{css:D.container},o("div",{css:D.colorMapIntervals},t.entries.map((e,t)=>o("div",{key:t,css:D.colorMapEntry},o("div",{css:D.colorMapEntryVisual,style:{backgroundColor:e.color}}),o("div",{css:D.colorMapEntryLabel},e.quantity)))))};delete v.Icon.Default.prototype._getIconUrl,v.Icon.Default.mergeOptions({iconRetinaUrl:require("leaflet/dist/images/marker-icon-2x.png"),iconUrl:require("leaflet/dist/images/marker-icon.png"),shadowUrl:require("leaflet/dist/images/marker-shadow.png")});class W extends s.Component{constructor(){super(...arguments),this.leafletMapRef=s.createRef(),this.state={}}onClick(e){return t=this,o=void 0,n=function*(){this.props.onClick(e)},new((i=void 0)||(i=Promise))((function(e,r){function a(e){try{s(n.next(e))}catch(e){r(e)}}function l(e){try{s(n.throw(e))}catch(e){r(e)}}function s(t){t.done?e(t.value):new i((function(e){e(t.value)})).then(a,l)}s((n=n.apply(t,o||[])).next())}));var t,o,i,n}bubbleChanges(e){const{lat:t,lng:o}=e.target.getCenter(),i=e.target.getZoom();this.props.onChange({lat:t,lng:o,zoom:i})}componentDidMount(){this.watchResize()}watchResize(){const e=new y(e=>{d(this.leafletMapRef.current)||this.leafletMapRef.current.leafletElement.invalidateSize()}),t=document.querySelector(".leaflet-container");t&&e.observe(t)}render(){const{baselayers:e,overlayers:i}=this.props;return this.leafletMapRef.current&&this.leafletMapRef.current.leafletElement.setMaxZoom(this.props.maxZoom),o(g,{ref:this.leafletMapRef,center:[this.props.lat,this.props.lng],zoom:this.props.zoom,maxZoom:18,zoomControl:!1,onclick:this.onClick.bind(this),onzoomend:this.bubbleChanges.bind(this),onmoveend:this.bubbleChanges.bind(this),crs:this.props.crs||w.EPSG4326,css:t`
          width: 100%;
          height: 100%;

          ${!this.props.showAttribution&&t`
              .leaflet-control-attribution {
                display: none;
              }
            `}
        `},e.map((e,t)=>o(x,{key:`baselayer-${t}`,attribution:e.attribution,url:e.url})),i.map((e,t)=>o(b,Object.assign({key:t},e))),o(u,{position:"bottomright",metric:!0,ial:!1,updateWhenIdle:!0}),this.props.children)}}W.defaultProps={lat:51.00079308917475,lng:4.498901367187501,zoom:9,maxZoom:18,baselayers:[],overlayers:[],overlayerOpacity:.75,onClick:p,onChange:p,showAttribution:!1};const U=o("svg",{xmlns:"http://www.w3.org/2000/svg",width:"16",height:"16",viewBox:"0 0 16 16"},o("defs",null,o("clipPath",{id:"clip-path"},o("rect",{width:"16",height:"16",fill:"none"}))),o("g",{id:"element_checkbox_checked",clipPath:"url(#clip-path)"},o("path",{id:"check-square",d:"M14.286,48H1.714A1.714,1.714,0,0,1,0,46.286V33.714A1.714,1.714,0,0,1,1.714,32H14.286A1.714,1.714,0,0,1,16,33.714V46.286A1.714,1.714,0,0,1,14.286,48Zm-7.31-3.5,6.571-6.571a.571.571,0,0,0,0-.808l-.808-.808a.571.571,0,0,0-.808,0L6.571,41.669l-2.5-2.5a.571.571,0,0,0-.808,0l-.808.808a.571.571,0,0,0,0,.808L6.167,44.5a.571.571,0,0,0,.808,0Z",transform:"translate(0 -32)",fill:"#33a3dc"}))),X=o("svg",{xmlns:"http://www.w3.org/2000/svg",width:"16",height:"16",viewBox:"0 0 16 16"},o("defs",null,o("clipPath",{id:"clip-path"},o("rect",{width:"16",height:"16",fill:"none"}))),o("g",{id:"element_checkbox_unchecked",clipPath:"url(#clip-path)"},o("g",{id:"Rectangle_185","data-name":"Rectangle 185",fill:"none",stroke:"#bbb",strokeWidth:"1"},o("rect",{width:"16",height:"16",rx:"2",stroke:"none"}),o("rect",{x:"0.5",y:"0.5",width:"15",height:"15",rx:"1.5",fill:"none"})))),Y=o("svg",{xmlns:"http://www.w3.org/2000/svg",width:"16",height:"16",viewBox:"0 0 16 16"},o("defs",null,o("clipPath",{id:"clip-path"},o("rect",{width:"16",height:"16",fill:"none"}))),o("g",{id:"Component",clipPath:"url(#clip-path)"},o("g",{id:"Rectangle_185","data-name":"Rectangle 185",fill:"none",stroke:"#bbb",strokeWidth:"1"},o("rect",{width:"16",height:"16",rx:"2",stroke:"none"}),o("rect",{x:"0.5",y:"0.5",width:"15",height:"15",rx:"1.5",fill:"none"})),o("line",{id:"Line_127","data-name":"Line 127",x2:"8",transform:"translate(4 8)",fill:"none",stroke:"#bbb",strokeWidth:"1"}),o("g",{id:"Ellipse_38","data-name":"Ellipse 38",transform:"translate(3.5 7.5)",fill:"#bbb",stroke:"#bbb",strokeWidth:"1"},o("circle",{cx:"0.5",cy:"0.5",r:"0.5",stroke:"none"}),o("circle",{cx:"0.5",cy:"0.5",fill:"none"})),o("g",{id:"Ellipse_39","data-name":"Ellipse 39",transform:"translate(11.5 7.5)",fill:"#bbb",stroke:"#bbb",strokeWidth:"1"},o("circle",{cx:"0.5",cy:"0.5",r:"0.5",stroke:"none"}),o("circle",{cx:"0.5",cy:"0.5",fill:"none"})))),J=$.div(t`
    display: inline-block;
    vertical-align: middle;
    position: relative;
    margin-right: 5px;
    width: 14px;
    height: 14px;

    & svg {
      max-width: 14px;
      max-height: 14px;
    }
  `),K=e=>{const{checkedState:t,uncheckedState:i,indeterminateState:n,onClick:r,status:a}=e,l="checked"===a,s="unchecked"===a,c="indeterminate"===a;return o(J,Object.assign({onClick:r},e),l&&t&&t,l&&!t&&U,s&&i&&i,s&&!i&&X,c&&n&&n,c&&!n&&Y)};K.defaultProps={onClick:p};const Q=$.div(m`
    margin-right: 5px;
    width: 34px;
    cursor: pointer;
  `),ee=({onClick:e,isActive:t,fillColor:o})=>{const i=`\n    .a {\n      fill:none;\n    }\n    .b {\n      clip-path:url(#a);\n    }\n    .c {\n      fill: ${t?o:"#ddd"};\n      transition: all 0.2s ease-in-out;\n    }\n    .d {\n      fill:#fff;\n    }\n    circle {\n      transform: translate(${(e=>e?"15px":"3px")(t)}, 2px);\n      transition: all 0.2s ease-in-out;\n    }\n  `,n=s.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"29.598",height:"16",viewBox:"0 0 29.598 16"},s.createElement("defs",null,s.createElement("style",null,i),s.createElement("clipPath",{id:"a"},s.createElement("rect",{className:"a",width:"29.598",height:"16"}))),s.createElement("g",{className:"b",transform:"translate(0 0)"},s.createElement("path",{className:"c",d:"M7.4,0H22.2c4.087,0,7.4,3.582,7.4,8s-3.313,8-7.4,8H7.4C3.313,16,0,12.418,0,8S3.313,0,7.4,0Z"}),s.createElement("circle",{className:"d",cx:"6",cy:"6",r:"6"})));return s.createElement(Q,{onClick:e},n)};ee.defaultProps={isActive:!1,fillColor:"#359ea6"};const te={container:m`
    position: relative;
    width: fit-content;
  `,toggle:m`
    width: fit-content;
  `,expandableArea:m`
    position: absolute;
    width: auto;
    height: auto;
    top: 100%;
    z-index: 999;
    background-color: white;
  `,defaultToggle:m`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: fit-content;
    min-width: 100px;
    padding: 8px 15px 9px;

    border: 1px solid #1e2c47;
    background-color: white;
    cursor: pointer;

    color: rgba(30, 44, 71, 0.4);
    user-select: none;
  `,toggleCaret:m`
    padding-left: 10px;
  `,defaultExpandableArea:m`
    padding: 18px 15px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    min-width: 100px;
  `,dropdownItem:m`
    padding: 8px 15px;
    cursor: pointer;
    width: fit-content;
    min-width: 100px;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 0;
    border-bottom: 1px solid #ddd;

    &:hover {
      background-color: #efefef;
    }
  `,dropdownItemActive:m`
    /* @include OpenSansCondensedBold; */
    font-weight: bold;
  `},oe=s.createContext({}),ie=oe.Provider,ne=oe.Consumer,re=e=>{const t=k(!1);return o(ie,{value:{isOpen:t}},o("div",{css:te.container},o(C,{onOutsideClick:()=>{t.setFalse()}},o("div",{css:te.toggle,onClick:t.toggle},e.toggle),t.value&&o("div",{css:te.expandableArea},e.expandableArea))))},ae=e=>o("div",{css:te.defaultToggle},e.value,o("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 320 512",style:{fill:"#FFE25A",width:"14px",height:"14px"},css:te.toggleCaret},o("path",{d:"M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"}))),le=e=>o("div",{css:te.defaultExpandableArea},e.children),se=e=>o(ne,null,({isOpen:t})=>o("div",{css:[te.dropdownItem,...e.isActive?[te.dropdownItemActive]:[]],onClick:()=>{t.setFalse(),e.onClick()}},e.value)),ce=e=>t`
  @media screen and (hover: hover) {
    position: relative;
    display: flex;
    pointer-events: all;
    width: fit-content;
    height: fit-content;

    /* Show the tooltip text when you mouse over the tooltip container */
    &:hover .tooltipText {
      visibility: visible;
      opacity: 1;
    }
  }

  .tooltipText {
    position: absolute;
    z-index: 99999;
    width: max-content;
    pointer-events: none;
    background-color: #212121;
    color: #fff;
    font-size: 1em;
    font-weight: normal;
    text-align: center;
    padding: 5px 13px;
    border-radius: 5px;
    pointer-events: none;
    visibility: hidden;

    /* fade in the tooltip */
    opacity: 0;
    transition-delay: ${e.delay}ms;

    ${"right"===e.position&&t`
        left: calc(100% + 9px);
        top: 50%;
        transform: translateY(-50%);

        ${e.arrow&&t`
            &::after {
              content: ' ';
              position: absolute;
              top: 50%;
              right: 100%; /* To the left of the tooltip */
              margin-top: -5px;
              border-width: 5px;
              border-style: solid;
              border-color: transparent black transparent transparent;
            }
          `}
      `}

        ${"top"===e.position&&t`
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);

            ${e.arrow&&t`
                &::after {
                  content: ' ';
                  position: absolute;
                  top: 100%; /* At the bottom of the tooltip */
                  left: 50%;
                  margin-left: -5px;
                  border-width: 5px;
                  border-style: solid;
                  border-color: black transparent transparent transparent;
                }
              `}
          `}

        ${"bottom"===e.position&&t`
            top: calc(100% + 9px);
            left: 50%;
            transform: translateX(-50%);

            ${e.arrow&&t`
                &::after {
                  content: ' ';
                  position: absolute;
                  bottom: 100%; /* At the top of the tooltip */
                  left: 50%;
                  margin-left: -5px;
                  border-width: 5px;
                  border-style: solid;
                  border-color: transparent transparent black transparent;
                }
              `};
          `}

    ${"left"===e.position&&t`
        top: 50%;
        transform: translateY(-50%);
        right: calc(100% + 9px);

        ${e.arrow&&t`
            &::after {
              content: ' ';
              position: absolute;
              top: 50%;
              left: 100%; /* To the right of the tooltip */
              margin-top: -5px;
              border-width: 5px;
              border-style: solid;
              border-color: transparent transparent transparent black;
            }
          `}
      `};
  }
`,pe=e=>o("div",{css:ce(e),className:e.className},o("div",{className:"tooltipText"},o("span",null,e.text)),e.children);pe.defaultProps={position:"left",arrow:!0,delay:0};const de=e=>{const o=Object.assign(Object.assign({},z),e.theme);return t`
    position: relative;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    outline: none;
    box-sizing: border-box;
    text-decoration: none;
    border-right: 4px solid transparent;
    background-color: ${o.navigationItem.default.backgroundColor};

    > svg {
      fill: ${o.navigationItem.default.iconColor};
    }

    ${e.isActive&&t`
        flex-direction: column;
        border: 0;
        border-right: 4px solid ${o.navigationItem.active.borderColor};
        background-color: ${o.navigationItem.active.backgroundColor};

        > svg {
          fill: ${o.navigationItem.active.iconColor};
        }
      `};
  `},he=e(e=>o("div",{css:de(e)},e.children));he.defaultProps={isActive:!1};const fe=$.div(e=>m`
    display: inline-block;
    width: 15px;
    height: 15px;
    border: 0.5px solid ${e.borderColor?e.borderColor:"#BBBBBB"};
    border-radius: 100%;
    margin-right: 10px;

    ${e.isActive&&m`
        border: 5px solid
          ${e.activeBorderColor?e.activeBorderColor:"#33A3DC"};
        width: 6px;
        height: 6px;
        background-color: white;
      `};
  `),me={H1:e(e=>{const i=h(z,e.theme),{typography:n}=i;return o("h1",{css:t`
        font-family: ${n.h1.fontFamily};
        font-size: ${l(n.h1.fontSize,n.baseFontSize)};
      `,className:e.className},e.children)}),H2:e(e=>{const i=h(z,e.theme),{typography:n}=i;return o("h2",{css:t`
        font-family: ${i.typography.h2.fontFamily};
        font-size: ${l(n.h2.fontSize,n.baseFontSize)};
      `,className:e.className},e.children)}),H3:e(e=>{const i=h(z,e.theme),{typography:n}=i;return o("h3",{css:t`
        font-family: ${i.typography.h3.fontFamily};
        font-size: ${l(n.h3.fontSize,n.baseFontSize)};
      `,className:e.className},e.children)}),H4:e(e=>{const i=h(z,e.theme),{typography:n}=i;return o("h4",{css:t`
        font-family: ${i.typography.h4.fontFamily};
        font-size: ${l(n.h4.fontSize,n.baseFontSize)};
      `,className:e.className},e.children)}),Paragraph:e(e=>{const i=h(z,e.theme),{typography:n}=i;return o("p",{css:t`
        font-family: ${i.typography.paragraph.fontFamily};
        font-size: ${l(n.baseFontSize,n.baseFontSize)};
      `,className:e.className},e.children)})};export{K as CheckBox,re as Dropdown,le as DropdownExpandable,se as DropdownItem,ae as DropdownToggle,L as InputRange,B as Legend,G as LegendIntervals,j as LegendItemType,q as LegendRamp,W as Map,O as MapControl,S as MapControlButton,M as MapControlGroup,he as NavigationItem,fe as RadioButton,ee as Toggle,pe as Tooltip,me as Typography,_ as Window,z as theme};
